import Vue from 'vue'
import Router from 'vue-router'
import Groupes from '../components/Page/Groupes'
import Listes from '../components/Page/Listes'
import Genres from '../components/Page/Genres'
import Users from '../components/Page/users'
import AddGroupe from '../components/Page/AddGroupe'
import UpdateGroupe from '../components/Page/UpdateGroupe'
import Login from '../components/Page/Login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Racine',
      component: Groupes
    },
    {
      path: '/groupes',
      name: 'Groupes',
      component: Groupes
    },
    {
      path: '/listes',
      name: 'Listes',
      component: Listes
    },
    {
      path: '/genres',
      name: 'PJO - Genres',
      component: Genres
    },
    {
      path: '/users',
      name: 'PJO - Utilisateurs',
      component: Users
    },
    {
      path: '/addgroupe',
      name: 'PJO - Ajouter un groupe',
      component: AddGroupe
    },
    {
      path: '/updategroupe/:name',
      name: 'PJO - Mettre à jour un groupe',
      component: UpdateGroupe,
      props: true
    },
    {
      path: '/login',
      name: 'PJO - Ajouter un groupe',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js